import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { EditDialogComponent } from '../../../core/components/editDialog/editDialogComponent';
import { EditDialogInstance } from '../../../core/components/editDialog/editDialogService';
import { User } from '../../../core/entities/user/user';
import { CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { GrowthBookService } from '../../../core/services/growthbook.service';
import { LoadingService } from '../../../core/services/loading.service';
import { RolesService } from '../../../core/services/roles/roles.service';
import { Apollo } from 'apollo-angular';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { Tour, TourInput } from '../../shared/entities/tour';
import * as fromGraphQl from './graphql';

@Component({
  // tslint:disable-next-line:component-selector
  selector: "app-tour-settings-dialog",
  templateUrl: "tour-settings-dialog.html",
  styleUrls: ["./tour-settings-dialog.scss"]
})
export class TourSettingsDialogComponent
implements EditDialogInstance{

  tour: Tour;
  anchorDate: Date = new Date();
  drivers = [];
  departureAddresses = [];
  arrivalAddresses = [];
  public tourFormGroup: FormGroup;
  // public resources: Resource[];
  commandTemplate: CommandTemplate


  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private datePipe: DatePipe,
    public rolesService: RolesService,
    private apollo: Apollo,
    public loadingService: LoadingService,
    private growthBookService: GrowthBookService,
  ) {
    this.tourFormGroup = new FormGroup({});
    // add form controls
    this.tourFormGroup.addControl('resource', new FormControl());
    this.tourFormGroup.addControl('assignee', new FormControl());
    this.tourFormGroup.addControl('dateRange', new FormControl());
    this.tourFormGroup.addControl('departureAddress', new FormControl());
    this.tourFormGroup.addControl('arrivalAddress', new FormControl());
    this.tourFormGroup.addControl('startDateControl', new FormControl());
    this.tourFormGroup.addControl('endDateControl', new FormControl());
    this.tourFormGroup.addControl('description', new FormControl());

    this.commandTemplate = this.config?.data.commandTemplate;

    let tourId =this.commandTemplate?.parameters?.filter(
      parameter => parameter.name === 'commandProviderId'
    )?.[0]?.value;

    this.apollo.query<fromGraphQl.TourSettingsDialogQueryResponse>({
      query: fromGraphQl.TOUR_SETTINGS_DIALOG_QUERY,
      variables: {
        tourId: tourId
      },
      fetchPolicy: 'network-only',
    })
    .pipe(take(1))
    .subscribe(data => {
      console.log('data', data)
      this.tour = new Tour(data.data.tour);
      for (let candidate of this.tour?.driverCandidates){
        this.drivers.push({
         id: candidate?.id,
         name: this.getName(candidate)
        })
      }
      for (let address of this.tour?.possibleStartAddresses){
        this.departureAddresses.push({
         id: address?.id,
         name: address?.getAddressString()
        })
      }
      for (let address of this.tour?.possibleEndAddresses){
        this.arrivalAddresses.push({
         id: address?.id,
         name: address?.getAddressString()
        })
      }
      this.initForm();
    });
    // this.resources = data.resources;

  }
  initForm() {
    // Anker ist der Tag, zu dem die Tour gehört (dateTimeReference), nicht der Tag des Betrachters
    // und nicht der gespeicherte Abfahrtstag. Ein gesetzter Abfahrtszeitpunkt steckt bereits im
    // FormControl und verdeckt den Anker in der Anzeige — als Anker wäre er nur genau dann sichtbar,
    // wenn der User das Feld leert, und dort ist er falsch. scheduledDepartureDateTime bleibt daher
    // nur Fallback für Alt-Touren ohne dateTimeReference, dann heute.
    const anchorSource = this.tour?.dateTimeReference || this.tour?.scheduledDepartureDateTime;
    const parsed = anchorSource ? new Date(anchorSource) : null;
    const anchorD = parsed && !isNaN(parsed.getTime()) ? parsed : new Date();
    this.anchorDate = new Date(anchorD.getFullYear(), anchorD.getMonth(), anchorD.getDate());

    this.tourFormGroup.patchValue({
      assignee: this.tour?.driver?.id,
      resource: this.tour?.resource?.id,
      // startTime: this.datePipe.transform(this.tour?.scheduledDepartureDateTime, 'HH:mm', 'CET'),
      // endTime: this.datePipe.transform(this.tour?.scheduledArrivalDateTime, 'HH:mm', 'CET'),
      // startDateControl: this.tour?.scheduledDepartureDateTime ? this.tour?.scheduledDepartureDateTime : null,
      // endDateControl: this.tour?.scheduledArrivalDateTime ? this.tour?.scheduledArrivalDateTime : null,
      description: this.tour?.note,
      departureAddress: this.tour?.departureAddress?.id,
      arrivalAddress: this.tour?.arrivalAddress?.id
    });
    if (this.tour?.state === 'RUNNING') {
      this.tourFormGroup?.controls['assignee']?.disable();
      this.tourFormGroup?.controls['resource']?.disable();
      this.tourFormGroup?.controls['startDateControl']?.disable();
      this.tourFormGroup?.controls['startTime']?.disable();
      this.tourFormGroup?.controls['departureAddress']?.disable();
    }
    this.tourFormGroup?.setValidators(this.dateRangeValidator);
    let fromDate = this.tour?.scheduledDepartureDateTime ? new Date(this.tour?.scheduledDepartureDateTime ): null;
    let toDate = this.tour?.scheduledArrivalDateTime ? new Date( this.tour?.scheduledArrivalDateTime) : null;
    this.tourFormGroup.get('startDateControl')?.setValue(fromDate);
    this.tourFormGroup.get('endDateControl')?.setValue(toDate);

    if (this.useNewDateTimeControls) {
      if (!this.tourFormGroup.get('startDateControl')?.value) {
        this.tourFormGroup.get('endDateControl')?.disable();
      }
      this.tourFormGroup.get('startDateControl')?.valueChanges.subscribe(v => {
        if (!v) {
          this.tourFormGroup.get('endDateControl')?.setValue(null);
          this.tourFormGroup.get('endDateControl')?.disable();
        } else {
          this.tourFormGroup.get('endDateControl')?.enable();
        }
      });
    }

  }
  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    const formModel = this.tourFormGroup.value;
    let tourModel = new TourInput();
    tourModel.id = this.tour.id;
    tourModel.locationId = this.tour?.location?.id;

    if (this.tourFormGroup?.controls['description']?.dirty) {
      tourModel.note = formModel?.description;
    } else {
     tourModel.note = this.tour.note;
    }
    if (this.tourFormGroup?.controls['assignee']?.dirty) {
       tourModel.assignee = formModel?.assignee;
    } else {
      tourModel.assignee = this.tour.driver?.id;
    }
    if (this.tourFormGroup?.controls['resource']?.dirty) {
      tourModel.resource = formModel?.resource;
    } else {
     tourModel.resource = this.tour.resource?.id;
    }

    const startDateValue = this.tourFormGroup.get('startDateControl')?.value;
    if (startDateValue) {
      tourModel.scheduledDepartureDateTime = new Date(startDateValue).toISOString();
    }
    const endDateValue = this.tourFormGroup.get('endDateControl')?.value;
    if (endDateValue) {
      tourModel.scheduledArrivalDateTime = new Date(endDateValue).toISOString();
    }

    if (formModel?.arrivalAddress) {
      tourModel.arrivalAddressId = formModel?.arrivalAddress;
    } else {
      tourModel.arrivalAddressId = formModel.arrivalAddress;
    }
    if (formModel?.departureAddress) {
      tourModel.departureAddressId = formModel?.departureAddress;
    } else {
      tourModel.departureAddressId = formModel.departureAddress;
    }
    this.ref.close(tourModel);


  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.tourFormGroup;
  }

  getName(user: User): string {
    if (user?.firstName && user?.lastName) {
      return user.firstName + ' ' + user.lastName;
    } else if (user?.firstName || user?.lastName) {
      return user?.firstName ? user?.firstName : user?.lastName;
    } else {
      return '-'
    }
  }

  dateRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup; // Cast to FormGroup
    const fromDate = formGroup.get('startDateControl')?.value;
    const toDate = formGroup.get('endDateControl')?.value;

    if (fromDate && toDate && fromDate >= toDate) {
      return { dateRangeInvalid: true }; // Error if 'toDate' is earlier than or same as 'fromDate'
    }
    return null; // No error
  }


  get useNewDateTimeControls(): boolean {
    return this.growthBookService.isFeatureEnabled('frontendWeb.anchorDateTimeSelektor');
  }

  get dateRangeInvalid(): boolean {
    return this.tourFormGroup?.hasError('dateRangeInvalid');
  }

  get startDateValue(): Date | null {
    return this.tourFormGroup.get('startDateControl')?.value ?? null;
  }

  /**
   * Anker fuer das Endfeld: der Tag des aktuell gewaehlten Starts, sonst der Tag der Tour.
   * Als Getter, damit er dem Startwert folgt — konsistent zu startDateValue, das schon minDate
   * speist. Ist der Start leer, ist das Endfeld ohnehin deaktiviert.
   */
  get endAnchorDate(): Date {
    const start = this.startDateValue;
    if (!start) {
      return this.anchorDate;
    }
    return new Date(start.getFullYear(), start.getMonth(), start.getDate());
  }
}
